// @ngInject
function DiscountsApiService($rootScope, $q, $window, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'discounts';
  
    return {
      getDiscounts: getDiscounts,
      getDiscount: getDiscount,
      getDiscountCopy: getDiscountCopy,
      saveDiscount: saveDiscount,
      validateItemGroups: validateItemGroups,
      deleteDiscount: ResourcesService.apiFactory.delete(endpoint, 'Discount'),
      getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
      getMainGroups: ResourcesService.apiFactory.get(endpoint + '/maingroups'),
      getDiscountTypes: ResourcesService.apiFactory.get(endpoint + '/types'),
      getBrands: getBrands,
      getItemGroups: getItemGroups,
      approveDiscount: approveDiscount,
      cancelDiscount: cancelDiscount,

      // Links
      canEditDiscount: canEditDiscount,
      canApproveDiscount: canApproveDiscount,
      canCancelDiscount: canCancelDiscount,
      canDeleteDiscount: canDeleteDiscount,
      claimCanCreateDiscount: claimCanCreateDiscount,
      claimCanUpdateDiscount: claimCanUpdateDiscount,
      claimCanDeleteDiscount: claimCanDeleteDiscount
    };

    function hasLink(links, rel) {
      var link = _.find(links, function (o) {
          return o.rel === rel;
      });

      if (link) {
          return true;
      }

      return false;
    }

    function canEditDiscount(links) {
      return hasLink(links, 'can_edit');
    }
    
    function canApproveDiscount(links) {
      return hasLink(links, 'can_approve');
    }

    function canCancelDiscount(links) {
      return hasLink(links, 'can_cancel');
    }
    
    function canDeleteDiscount(links) {
      return hasLink(links, 'can_delete');
    }

    function claimCanUpdateDiscount(links) {
      return hasLink(links, 'claim_can_update');
    }
    function claimCanCreateDiscount(links) {
      return hasLink(links, 'claim_can_create');
    }
    function claimCanDeleteDiscount(links) {
      return hasLink(links, 'claim_can_delete');
    }

    function approveDiscount(discountId){
      var deferred = $q.defer();

      DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + discountId + '/confirmation')
        .then(function (response) {
          deferred.resolve(response.data);
        }, function (error) {
          deferred.reject(error);
        });

        return deferred.promise;
    }
    
    function cancelDiscount(discountId){
      var deferred = $q.defer();

      DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/' + discountId + '/cancellation')
        .then(function (response) {
          deferred.resolve(response.data);
        }, function (error) {
          deferred.reject(error);
        });

        return deferred.promise;
    }

    function validateItemGroups(discountId, itemGroups, startDate, endDate, salesChannelId){
      var deferred = $q.defer();

      var tempStartDate = startDate;
      tempStartDate = new Date(tempStartDate);
      startDate = new Date(Date.UTC(tempStartDate.getFullYear(), tempStartDate.getMonth(), tempStartDate.getDate()));
      var tempEndDate = endDate;
      tempEndDate = new Date(tempEndDate);
      endDate = new Date(Date.UTC(tempEndDate.getFullYear(), tempEndDate.getMonth(), tempEndDate.getDate(), 23, 59, 59, 0));

      var request = {
        'discountId': discountId,
        'itemGroups' : itemGroups,
        'startDate': startDate,
        'endDate': endDate,
        'salesChannelId': salesChannelId
      };

      var jsonRequest = JSON.stringify(request);

      DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/validateitemgroups', jsonRequest).then(function(response){
        deferred.resolve(response.data);
      },function(error) {
        deferred.reject(handleError(error));
      });

      return deferred.promise;
    }

    function getBrands(mainGroups) {
      var deferred = $q.defer();
      var request = [];

      _.forEach(mainGroups, function(mainGroup){
        request.push(mainGroup.id);
      });

      var jsonRequest = JSON.stringify(request);

      DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/brands', jsonRequest).then(function (response) {
        deferred.resolve(response.data);
      }, function(error) {
        deferred.reject(handleError(error));
      });

      return deferred.promise;
    }

    function getItemGroups(brands, mainGroups) {
      var deferred = $q.defer();

      var request = {
        mainGroupIds: [],
        brandIds: []
      };

      _.forEach(mainGroups, function(mainGroup){
        request.mainGroupIds.push(mainGroup.id);
      });
      _.forEach(brands, function(brand){
        request.brandIds.push(brand.id);
      });

      var jsonRequest = JSON.stringify(request);

      DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/itemgroups', jsonRequest).then(function (response) {
        deferred.resolve(response.data);
      }, function(error) {
        deferred.reject(handleError(error));
      });

      return deferred.promise;
    }

    function getDiscounts(filter, currentPage, pageSize, showCancelled, showApproved, showCompleted, monthsBack) {
      var deferred = $q.defer();

      var params = {};
      if(!_.isEmpty(filter)){
        params.filter = filter;
      }
      params.currentPage = currentPage;
      params.pageSize = pageSize;
      params.showCancelled = showCancelled;
      params.showApproved = showApproved;
      params.showCompleted = showCompleted;
      params.monthsBack = monthsBack;

      DSHttpAdapter.GET(DS.defaults.basePath + endpoint, { params: params}).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getDiscount(id) {
      var deferred = $q.defer();
      DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + id)
        .then(function (response) {
          deferred.resolve(response.data);
        }, function (error) {
          deferred.reject(error);
        });

        return deferred.promise;
    }

    function getDiscountCopy(id) {
      var deferred = $q.defer();
      DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + id + '/copy')
        .then(function (response) {
          deferred.resolve(response.data);
        }, function (error) {
          deferred.reject(error);
        });

        return deferred.promise;
    }

    function saveDiscount(discount) {
      
      var deferred = $q.defer();

      var discountData = discount;
      /*var discountData = {
        id : discount.id,
        name : discount.name,
        startDate : discount.startDate,
        endDate : discount.endDate,
        status : discount.status,
        salesChannel : discount.salesChannel,
        itemGroups : discount.itemGroups,
        description : discount.description
      }*/

      var sendDiscountData = angular.copy(discountData);

      var startDate = sendDiscountData.startDate;
      startDate = new Date(startDate);
      sendDiscountData.startDate = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
      var endDate = sendDiscountData.endDate;
      endDate = new Date(endDate);
      sendDiscountData.endDate = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()));

      var jsonData = JSON.stringify(sendDiscountData);

      DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/save', jsonData).then(function (response) {
        deferred.resolve(response.data);
        $rootScope.$emit('Discount.Updated', response.data);
        $rootScope.$emit('Discount.Changed', response.data);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }
}
    angular
      .module('discounts.api', [])
      .factory('DiscountsApiService', DiscountsApiService);
  